export { TemplatesModule } from './templates.module';
export { TemplateService } from './template.service';

export { TemplateModifyComponent } from './template-modify/template-modify.component';
export { TemplateManageComponent } from './template-manage/template-manage.component';

export * from './template';
